export default __webpack_public_path__ + "static/media/polk_p_legendary.52ec25ad.png";